import { render, staticRenderFns } from "./salaryDetail.vue?vue&type=template&id=04d8660b&"
import script from "./salaryDetail.vue?vue&type=script&lang=js&"
export * from "./salaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./salaryDetail.vue?vue&type=style&index=0&id=04d8660b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports